<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { CognitoUserPool } from "amazon-cognito-identity-js";
export default {
  computed: {
    ...mapState(["PoolData", "UserPool", "IdToken", "AccessGroups", "UserObject"])
  },

  mounted() {
    const userpool = new CognitoUserPool(Object.assign({}, this.PoolData));
    const cognitoUser = userpool.getCurrentUser(); // get the current user from the user pool.
    this.saveUserPool(userpool);
    // 通过用户获取IdToken
    if (cognitoUser) {
      cognitoUser.getSession((err, session) => {
        if (err) {
          this.$message.error(err);
        } else if (!session.isValid()) {
          this.saveIdToken(null);
        } else {
          let accessGroups = session.getIdToken().payload["cognito:groups"];
          let username = session.getIdToken().payload["cognito:username"];
          this.saveAccessGroups(accessGroups);
          this.saveUserName(username);
          this.saveIdToken(session.getIdToken().getJwtToken());
          this.saveCognitoUser(cognitoUser);

          // finally, retrieve the user object from the session storage, and loop through the array of companies and store it in a map.
          let userObject = JSON.parse(sessionStorage.getItem("UserObject"));
          if (userObject) {
            this.saveUserObject(userObject);
            this.saveSingleCompanyUser(userObject.singleCompanyUser);
            let companyMap = new Map();
            let companyArray = userObject.authorizedCompanies;
            companyArray.forEach(company => {
              companyMap.set(company.company, {
                depots: company.depot,
                region: company.region,
                hasTransformer: company.hasTransformer
              });
            });
            this.saveCompanyMap(companyMap);
          }
        }
      });
    } else {
      this.saveIdToken(null);
    }
  },

  beforeUpdate() {
    // save the user object in session storage before updating/refreshing the page.
    sessionStorage.setItem("UserObject", JSON.stringify(this.UserObject));
  },

  methods: {
    ...mapMutations([
      "saveUserPool",
      "saveIdToken",
      "saveAccessGroups",
      "saveUserName",
      "saveCognitoUser",
      "saveUserObject",
      "saveCompanyMap",
      "saveSingleCompanyUser"
    ])
  }
};
</script>

<style lang="less">
html,
body {
  height: 100%;
}
#app {
  height: 100%;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
